import { MessageSquare } from "lucide-react";
import ChatPanel from "@/components/chat/ChatPanel";

export default function StudentMessages() {
  return (
    <div data-testid="student-messages-page" className="w-full max-w-full min-w-0 h-full flex flex-col overflow-hidden">
      <h1 className="font-heading text-3xl font-bold tracking-tight uppercase text-slate-900 mb-4 shrink-0">Messages</h1>
      <div className="flex-1 min-h-0">
        <ChatPanel mode="student" />
      </div>
    </div>
  );
}